(function() {
  'use strict';

  function PayPalResource ($q, $resource, URL_PAYPAL) {
    return $resource(URL_PAYPAL, {}, {
      authorize: {
        method: 'POST',
        url: URL_PAYPAL + '/paypal/authorize',
      },
      expressCheckout: {
        method: 'POST',
        url: URL_PAYPAL + '/paypal/pagamento/express-checkout/autorizacao',
      },
      disconnect: {
        method: 'POST',
        url: URL_PAYPAL + '/paypal/disconnect',
      },
      getTransactions: {
        method: 'GET',
        url: URL_PAYPAL + '/paypal/pedidos',
        params: {
          provider: '@provider',
          dataInicio: '@dataInicio',
          dataFim: '@dataFim',
          pagina: '@pagina',
          status: '@status',
        },
      },
    });
  }

  angular
    .module('mandaeApp')
    .factory('PayPalResource', PayPalResource);

})();
